import React, { FC, useState, useEffect } from 'react'
import { ActiveFilters } from '../components/active-filters'
import { Color } from '../components/colors'
import {
  useCurrentRefinements,
  useHits,
  useClearRefinements,
} from 'react-instantsearch-core'
import type { ProductHit } from '../components/product-card'
import { Card } from '../components/product-card'
import { Select } from '../components/select'
import { Sort } from '../components/sort'

export type Props = {
  hits_per_page: number
}

export const App: FC<Props> = ({ hits_per_page }) => {
  const { hits } = useHits<ProductHit>()

  const [filterState, setFilterState] = useState<boolean>(false)
  const [isActive, setIsActive] = useState<number>(-1)

  const { items: currentRefinements } = useCurrentRefinements()
  const { refine: clearAllRefinements } = useClearRefinements()
  const [filtersCleared, setFiltersCleared] = useState(false)

  // Filters
  const filtersDataItem = document.getElementById(
    'algolia-inspiration-filters-json'
  )
  const filters =
    filtersDataItem !== null ? JSON.parse(filtersDataItem?.innerText) : ''

  /*console.log('FILTERS:')
  console.log(filters)*/

  useEffect(() => {
    function handleClickOutside(event) {
      const isOutsideFilters = !event.target.closest(".Algolia-filters")
      const isOutsideNav = !event.target.closest(".Algolia-filterButton")
      const isOutsideDropdown = !event.target.closest(".customDropdown-DropdownContainer")
      if (isOutsideFilters && isOutsideNav && isOutsideDropdown) {
        setFilterState(false)
        setOpenDropdown(null)
      }
    }

    document.addEventListener("click", handleClickOutside)
    return () => {
      document.removeEventListener("click", handleClickOutside)
    }
  }, [])

  useEffect(() => {
    if (filtersCleared) {
      setFiltersCleared(false)
    }
  }, [filtersCleared])

  function openFilters() {
    setFilterState(!filterState)
    if (filterState) {
      setOpenDropdown(null)
    }
  }

  function goToPrev(e: number) {
    setIsActive(e)
  }

  function goToNext(e: number) {
    setIsActive(e)
  }

  function deactivate() {
    setIsActive(-1)
  }

  const [openDropdown, setOpenDropdown] = useState(null)

  const toggleDropdown = (dropdownName) => {
    setOpenDropdown(openDropdown === dropdownName ? null : dropdownName)
  }

  return (
    <div>
      {/* Filter bar */}
      <div className="Algolia-nav">
        <div className="Algolia-navBody">
          <div className="Algolia-filtersGrid">
            <div
              className={`Algolia-filterButton ${filterState ? 'open' : ''} `}
              onClick={openFilters}
            >
              Filters{' '}
              <ActiveFilters excludedAttributes={['named_tags.is_parent']} />
            </div>
            {currentRefinements.length > 0 && (
              <button className="Algolia-clearFilters" onClick={() => clearAllRefinements()}>
                Clear Filters
              </button>
            )}

          </div>

          {/* As discussed with Rushabh, we are hiding this, for now */}
          {/* <div className="Algolia-colorsGrid">
          <Color
            attribute="named_tags.finish"
            title={filters.color.title}
            items={filters.color.filters}
          />
          </div> */}
          <div className="Algolia-sortGrid">
            <Sort
              items={[
                { label: 'Featured', value: 'shopify_products_published_at_desc' },
                {
                  label: 'Best sellers',
                  value: 'shopify_products_best_seller'
                },
                { label: 'New in', value: 'shopify_products_recently_ordered_count_desc' }
              ]}
            />
          </div>
        </div>

        {/* Filters body */}
        <div className={`Algolia-filters ${filterState ? 'open' : ''} `}>
          <div className="Algolia-filtersBody">
            {/* Application */}
            <div>
              <Select
                attribute="named_tags.application"
                title={filters.application.title}
                items={filters.application.filters}
                showIcon={false}
                isOpen={openDropdown === 'application'}
                onToggle={() => toggleDropdown('application')}
              />
            </div>

            {/* Design */}
            <div>
              <Select
                attribute="named_tags.design"
                title={filters.design.title}
                items={filters.design.filters}
                showIcon={false}
                isOpen={openDropdown === 'design'}
                onToggle={() => toggleDropdown('design')}
              />
            </div>

            {/* Finish */}
            <div>
              <Select
                attribute="named_tags.finish"
                title={filters.finish.title}
                items={filters.color.filters}
                showIcon={false}
                isOpen={openDropdown === 'finish'}
                onToggle={() => toggleDropdown('finish')}
              />
            </div>

            {/* Room */}
            <div>
              <Select
                attribute="named_tags.room"
                title={filters.room.title}
                items={filters.room.filters}
                showIcon={false}
                isOpen={openDropdown === 'room'}
                onToggle={() => toggleDropdown('room')}
              />
            </div>
            <div className="Algolia-filtersClose" onClick={openFilters}><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="19.5" stroke="#CCCCCC"></circle><path d="M26 14.7924L25.2075 14L20 19.2075L14.7925 14L14 14.7924L19.2075 20L14 25.2075L14.7925 25.9999L20 20.7924L25.2075 25.9999L26 25.2075L20.7925 20L26 14.7924Z" fill="black"></path></svg></div>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="Algolia-body">
        {hits?.map((item, i) => (
          <Card
            key={i}
            product={item}
            no={i}
            all_items_no={hits.length}
            goToPrev={goToPrev}
            goToNext={goToNext}
            is_active={isActive}
            deactivate={deactivate}
          />
        ))}
      </div>
    </div>
  )
}